import styled from 'styled-components'
import { linkColor } from './colors'

const FlatButton = styled.button`
  display: inline-block;
  padding: 6px 12px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 4px;

  color: ${(props) => (props.primary ? 'white' : linkColor)};
  background-color: ${(props) => (props.primary ? linkColor : 'white')};
  border-color: ${linkColor};
`

export default FlatButton
